import { render, staticRenderFns } from "./ResponsableMostrar.vue?vue&type=template&id=24301cdc"
import script from "./ResponsableMostrar.vue?vue&type=script&lang=js"
export * from "./ResponsableMostrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports